import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import i18n from '@/i18n';

export type SupportedLanguage = 'en' | 'es' | 'zh' | 'hi' | 'fr' | 'pt' | 'ar' | 'ko' | 'vi' | 'tl' | 'de';

/** Languages that are written right-to-left */
const RTL_LANGUAGES: SupportedLanguage[] = ['ar'];

/** Sync <html lang="..."> and <html dir="..."> with the active language */
export function applyDocumentLocale(lang: SupportedLanguage): void {
  document.documentElement.lang = lang;
  document.documentElement.dir = RTL_LANGUAGES.includes(lang) ? 'rtl' : 'ltr';
}

interface LanguageState {
  language: SupportedLanguage;
  setLanguage: (lang: SupportedLanguage) => void;
}

export const useLanguageStore = create<LanguageState>()(
  persist(
    (set) => ({
      language: 'en',
      setLanguage: (language) => {
        i18n.changeLanguage(language);
        applyDocumentLocale(language);
        set({ language });
      },
    }),
    {
      name: 'language-storage',
      onRehydrateStorage: () => (state) => {
        if (state?.language) {
          i18n.changeLanguage(state.language);
          applyDocumentLocale(state.language);
        }
      },
    }
  )
);
